import { IAgent, IVoice, Presenter } from '@d-id/types';
import { array, boolean, mixed, object, ObjectSchema, string } from 'yup';
import { coreAllowedCharacters } from './components/Content/VoiceScript/scriptFieldUtils';
import { CampaignFormValues } from './types';

const schema: ObjectSchema<CampaignFormValues> = object().shape({
    id: string().required(),
    title: string(),
    script_fields: array()
        .of(string().matches(coreAllowedCharacters, 'Script fields can only contain alphanumeric characters and underscores').required())
        .min(1, 'Script fields are required')
        .required('Script fields are required'),
    script: string().required('Script is required'),
    description: string(),
    logo_src: mixed<string | File>().test(
        'stringOrFile',
        'Logo must be a string or a file',
        value => !value || typeof value === 'string' || value instanceof File
    ),
    cta_enabled: boolean().required('CTA enabled is required'),
    cta_text: string(),
    cta_url: string().url('Please enter a valid URL'),
    cta_background_color: string(),
    // using mixed to avoid type issues. Yup requires to fully type the schema of the object
    voice: mixed<IVoice>().required('Voice is required'),
    agent: mixed<IAgent>().required('Agent is required'),
    presenter: mixed<Presenter>().required('Presenter is required'),
    is_stitch: boolean().required('Is Stitch is required'),
    script_html: string().optional(),
    name: string().optional(),
});

export default schema;
